import { actions } from 'portfolio-shared/state/reducers/globalNotificationsReducer';
const {
  addNotification: addNotificationAction,
  removeNotification: removeNotificationAction,
} = actions;

const ERROR_LEVEL = 'error';
const WARNING_LEVEL = 'warning';
const INFO_LEVEL = 'info';
const SUCCESS_LEVEL = 'success';

function addNotification(notification, type = INFO_LEVEL, dataTestName = 'notification') {
  return addNotificationAction(notification, type, dataTestName);
}

function removeNotification(uid) {
  return removeNotificationAction(uid);
}

function addNotificationNoAutoDismiss(localizedMessage, type, dataTestName = 'notification') {
  const notification = {
    message: localizedMessage,
    action: { label: 'OK' },
    autoDismiss: 0,
    dismissible: false,
  };
  return addNotification(notification, type, dataTestName);
}

export {
  ERROR_LEVEL,
  WARNING_LEVEL,
  INFO_LEVEL,
  SUCCESS_LEVEL,
  addNotification,
  addNotificationNoAutoDismiss,
  removeNotification,
};



// WEBPACK FOOTER //
// ./src/portfolio-shared/state/commands/globalNotificationsCommands.js